import { IconProps } from './IconProps';
export function ArrowRight(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M23.2438 12H0.757812"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.2578 23L22.9008 12.751C23.0072 12.6572 23.0924 12.5417 23.1508 12.4124C23.2092 12.2831 23.2394 12.1429 23.2394 12.001C23.2394 11.8591 23.2092 11.7189 23.1508 11.5896C23.0924 11.4603 23.0072 11.3448 22.9008 11.251L11.2578 1"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
